/**
 * Polyfill pour l'erreur "global is not defined".
 * Certaines librairies s'attendent à ce que l'objet `global` soit défini.
 */
(window as any).global = window;
